(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("hawk"), require("query-string"));
	else if(typeof define === 'function' && define.amd)
		define("taskcluster", ["hawk", "query-string"], factory);
	else if(typeof exports === 'object')
		exports["taskcluster"] = factory(require("hawk"), require("query-string"));
	else
		root["taskcluster"] = factory(root["hawk"], root["queryString"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_4__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition